import { CheckCircle, Loader2 } from 'lucide-react';
import { StaticMetricCardAlt } from '@/components/StaticMetricCardAlt';
import { dataService } from '@/services/data-service';
import { useQuery } from '@tanstack/react-query';
import type { Asset } from '@/types/asset';
import { Card, CardContent } from '@/components/ui/card';

interface KpiActiveAssetsProps {
  readonly className?: string;
}

export function KpiActiveAssets({ className }: KpiActiveAssetsProps): React.ReactElement {
  const { data: assetsResponse, isLoading } = useQuery({
    queryKey: ['assets'],
    queryFn: () => dataService.getAssets(),
  });

  const assets = assetsResponse?.data ?? [];
  const activeCount = assets.filter((a: Asset) => a.status === 'inService').length;
  const totalCount = assets.length;
  const percentage = totalCount > 0 ? ((activeCount / totalCount) * 100).toFixed(0) : '0';

  if (isLoading) {
    return (
      <Card className="overflow-hidden border-0">
        <CardContent className="p-6 h-[148px] flex flex-col items-center justify-center">
          <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
          <span className="text-sm text-muted-foreground mt-2">Loading...</span>
        </CardContent>
      </Card>
    );
  }

  return (
    <StaticMetricCardAlt
      title="Active Assets"
      value={activeCount.toLocaleString()}
      change={`${percentage}%`}
      changeLabel="of total"
      icon={CheckCircle}
      variant="info"
    />
  );
}
